import { Table } from 'antd';
import Title from 'antd/lib/typography/Title';
import React, { useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';
type IngredientItem = {
    ingredients_id: string;
    compound_name: string;
    // When the search failed, 'smile' / 'tanimoto' won't available & 'compound_name' copy 'ingredient_id'.
    smiles?: string;
    tanimoto?: string;
};

export type IngredientSimilarityResponseType = {
    ok: boolean;
    payload: {
        list: IngredientItem[];
        match: boolean;
    };
};

const similarityTable = (arr: IngredientItem[]) => {
    const columns = [
        {
            title: 'Ingredient Name',
            dataIndex: 'compound_name',
            key: 'compound_name',
        },
        {
            title: 'Tanimoto',
            dataIndex: 'tanimoto',
            key: 'tanimoto',
            render: function tanimoto(text: string, row: IngredientItem, index: number) {
                const simRate = parseFloat(text) * 100;
                const simColor = simRate > 75 ? 'olivedrab' : 'orange';
                return <div style={{ color: simColor }}>{simRate}%</div>;
            },
        },
        {
            title: 'Structure',
            dataIndex: 'smiles',
            key: 'smiles',
            render: function renderSimle(text: string, row: IngredientItem, index: number) {
                return <canvas key={`simile${index}`} id={`transformBallAndStick${index}`}></canvas>;
            },
        },
        {
            title: 'Drug Details',
            dataIndex: 'smiles',
            key: 'smiles',
            render: function detailLink(text: string, row: IngredientItem, index: number) {
                return (
                    <Link key={`detail${index}`} to={`/ingredient/detail/${row.ingredients_id}`}>
                        Show Details
                    </Link>
                );
            },
        },
    ];
    return (
        <Table
            columns={columns}
            dataSource={arr}
            rowKey={(record): string => record.compound_name + Math.floor(Math.random() * 1000)}
        />
    );
};

const PageIngredient: React.FC = () => {
    const history = useHistory();
    // We suppose the possible error handling happened in PageIngredient.tsx already
    const state = history.location.state as { payload: IngredientSimilarityResponseType };

    // Without these comment, the state can't allowed "goBack()" from Browser.
    console.log('state');
    console.log(state);
    if (state) {
        console.log('state.payload');
        console.log(state.payload);
    }

    useEffect(() => {
        if (!state) {
            history.push('/ingredient'); // jump back to search
            return;
        }
        const simResults = state.payload;
        const ChemDoodle = window.ChemDoodle;
        const arr = simResults.payload.list.map((e) =>
            fetch(`${API_SERVICE_BASE_URL}/sd-files/${e.ingredients_id}.sdf`),
        );
        Promise.all(arr).then((results) => {
            const textify = results.map((results) => results.text());
            Promise.all(textify).then((textArr) => {
                textArr.forEach((e, i) => {
                    const transformBallAndStick = new ChemDoodle.TransformCanvas3D(
                        `transformBallAndStick${i}`,
                        150,
                        150,
                    );
                    transformBallAndStick.specs.set3DRepresentation('Ball and Stick');
                    transformBallAndStick.specs.backgroundColor = 'black';
                    const molFile = e;
                    // set the coordinate multiplier to 1 to stay in Angstroms
                    const molecule = ChemDoodle.readMOL(molFile, 1);
                    transformBallAndStick.loadMolecule(molecule);
                });
            });
        });
    }, []);

    return (
        <div>
            {!state ? (
                <div>redirect to ingredient search</div>
            ) : (
                <div>
                    {state.payload.ok ? (
                        <div>
                            <Title level={2}>Similar ingredients list:</Title>
                            <div style={{ fontSize: '17px' }}>
                                <p>
                                    Drag on the image to view the ingredient structure. If you click the &quot;Show
                                    Details&quot;, you will be directed to ingredient detail page.
                                </p>
                            </div>
                            <div>{similarityTable(state.payload.payload.list)}</div>
                        </div>
                    ) : (
                        <div>Backend process failed</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PageIngredient;
